import React from "react";
import { HouseFill } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import logo from "../../Utils/Images/youBLogo.jpg";
import './styles.css'

function NavHeader() {
  return (
    <div className="headerContainer">
      <img src={logo} className="logo" alt="youB Logo" />

      <Link to={"/"}>
        <button className="homeButton">
          <HouseFill style={{ margin: 0 }} size={24} />
        </button>
      </Link>
    </div>
  );
}

export default NavHeader;
